import { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../../common/SummaryApi";
import ProductsRow, { ProductRowSkeleton } from "./ProductsRow";

const SubCategoryRowSection = ({ category }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!category) return;

    const fetchSubCategories = async () => {
      try {
        setLoading(true);

        const res = await axios({
          url: SummaryApi.getCategoryProducts.url(category),
          method: SummaryApi.getCategoryProducts.method,
        });

        if (res.data.success) {
            
          setRows(res.data.data || []);
        } else {
          setRows([]);
        }
      } catch (err) {
        console.error(err);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubCategories();
  }, [category]);

  if (loading) {
    return (
      <div className=" bg-[#FFFFFF] space-y-8">
        <ProductRowSkeleton />
      </div>
    );
  }

  return (
    <div className="space-y-8 bg-[#FFFFFF]">
      {rows.map((row) => (
        <ProductsRow
          key={row.subCategory}
          title={row.subCategory}
          products={row.products}
          showBuyNow={row.showBuyNow}
        />
      ))}
    </div>
  );
};

export default SubCategoryRowSection;
